import React from "react";
import DateFormatter from "../libraries/dateFormatter";
import I18n from "i18n";
import session from "models/sessionInstance";
import dayjs from 'libraries/dayjs'
import { formatNumber } from "../utils.js";
interface DatalakeClip {
  sourceInfo: {
    favicon_url: string;
    country: string;
    languages: string[];
    source_metadata: {
      logo_url: string;
      name: string;
      media_type: string;
      reach: string;
    };
  };
  publicationTime: number;
  aggregationTime: number;
}

export default function DatalakeClipPublicationInfo({
  sourceInfo,
  publicationTime,
  aggregationTime,
}: DatalakeClip) {
  const formattedPublishDate = DateFormatter.formatDate(
    dayjs.unix(publicationTime).utc()
  );
  const formattedAggregationDate = DateFormatter.formatRelativeDateTime(
    dayjs(aggregationTime)
  );
  const locale = session.get("locale");

  function sourceLanguageLocale() {
    const languages = sourceInfo.languages;
    if (languages.length === 0) return "";

    return languages
      .map((lang: string) => {
        if (lang === "German") {
          return "Deutsch";
        } else if (lang === "French") {
          return "Français";
        } else {
          return lang;
        }
      })
      .join(", ");
  }

  return (
    <>
      <div className="datalake-info-container">
        <div className="datalake-info-col datalake-info-col--left">
          <img
            className="source__agent-icon"
            src={sourceInfo.favicon_url}
            alt="favicon"
          />
          <div className="datalake-info-source-details">
            <div className="datalake-info-source-row">
              <span className="source__name">
                {sourceInfo.source_metadata.name}
              </span>
              <span className="meta__body" style={{ marginRight: 4 }}>
                {formatNumber(sourceInfo.source_metadata.reach, locale)}
              </span>
              <span className="meta__body">
                {I18n.t("webapp.agents.results.result_details.reach")}
              </span>
            </div>
            <span className="meta__body datalake-info-media-type">
              {I18n.t(`${sourceInfo.source_metadata.media_type}`)},{" "}
              {sourceInfo.country}, {sourceLanguageLocale()}
            </span>
          </div>
        </div>
        <div className="datalake-info-col datalake-info-col--right meta__body">
          <div className="datalake-info-date-row">
            <span>
              {I18n.t("webapp.agents.results.result_details.aggregation_date")}
            </span>
            <span className="datalake-aggregation-date-value">
              {formattedAggregationDate}
            </span>
          </div>
          <div className="datalake-info-date-row">
            <span>
              {I18n.t("webapp.agents.results.result_details.publication_date")}
            </span>
            <span className="datalake-publication-date-value">
              {formattedPublishDate}
            </span>
          </div>
        </div>
      </div>
      <hr className="separator mts" />
    </>
  );
}
